import { render } from "./TestKd.vue?vue&type=template&id=46c8ef9e&scoped=true"
import script from "./TestKd.vue?vue&type=script&lang=ts"
export * from "./TestKd.vue?vue&type=script&lang=ts"

import "./TestKd.vue?vue&type=style&index=0&id=46c8ef9e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-46c8ef9e"

export default script